import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  private apiUrl = environment.apiUrl;
  private messagesSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  constructor(
    private http: HttpClient
  ) { }

  getMessages(): Observable<any[]> {
    return this.messagesSubject.asObservable();
  }

  getChat(customerId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/conversations/${customerId}`)
      .pipe(catchError((error: any) => { throw error; }));
  }

  public loadChat(customerId: number): Observable<any> {
    return this.getChat(customerId);
  }

  public getInbox(): Observable<any> {
    return this.http.get(`${this.apiUrl}/getInbox`)
      .pipe(catchError((error: any) => { throw error; }));
  }

  /**
   * Obtiene el conteo de mensajes no leídos del usuario autenticado.
   * El token se añade automáticamente vía authInterceptor.
   */
  public getChatCount(): Observable<any> {
    return this.http.get(`${this.apiUrl}/chat/count`)
      .pipe(catchError((error: any) => { throw error; }));
  }

  public sendMessage(contactId: number, form: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/conversations/${contactId}/messages`, form);
  }

  public sendImage(contactId: number, image: File): Observable<any> {
    const formData = new FormData();
    formData.append('image', image);
    return this.http.post(`${this.apiUrl}/conversations/${contactId}/upload-image`, formData);
  }

  public sendImageBase64(contactId: number, imageBase64: string): Observable<any> {
    const body = { image_base64: imageBase64 };
    return this.http.post(`${this.apiUrl}/conversations/${contactId}/upload-image-base64`, body);
  }

  public readMessages(conversationId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/conversations/${conversationId}/mark-read`, {});
  }

  /**
   * Request backend to hide (soft-delete) a conversation for the current user.
   */
  public hideConversation(conversationId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/conversations/${conversationId}/hide`, {})
      .pipe(catchError((err) => { throw err; }));
  }

  /**
   * Start a free conversation for a given article.
   */
  public startConversation(articleId: number, receiverId?: number): Observable<any> {
    const body: any = { article_id: articleId };
    if (receiverId) {
      body.receiver_id = receiverId;
    }
    return this.http.post(`${this.apiUrl}/conversations/start`, body)
      .pipe(catchError((err) => { throw err; }));
  }
}
